module.exports = __webpack_public_path__ + "images/homeIcon-5abf0e61630d729aec8312d98ea93fad.svg";